/**
 * action_type / entity_type sözlük haritası.
 * Yeni kayıtlar gelirse sözlükte yoksa olduğu gibi gösterilir.
 */

export const ENTITY_TYPE_LABELS: Record<string, string> = {
  branch: "Şube",
  student: "Kursiyer",
  instructor: "Eğitmen",
  vehicle: "Araç",
  appointment: "Randevu",
  report: "Rapor",
  lesson_report: "Ders Raporu",
  auto_plan_run: "Otomatik Plan",
  notification: "Bildirim",
  user: "Kullanıcı",
  vehicle_tracking: "Araç Takibi",
  schedule_settings: "Rezervasyon Şablonu",
  tenant_settings: "Kurum Ayarları",
};

export const ACTION_TYPE_LABELS: Record<string, string> = {
  schedule_settings_saved: "Rezervasyon Şablonu Kaydedildi",
  branch_created: "Şube Oluşturuldu",
  branch_updated: "Şube Güncellendi",
  branch_active_changed: "Şube Durumu Değişti",
  student_created: "Kursiyer Oluşturuldu",
  student_updated: "Kursiyer Güncellendi",
  student_imported: "Kursiyer Excel İle Yüklendi",
  instructor_created: "Eğitmen Oluşturuldu",
  instructor_updated: "Eğitmen Güncellendi",
  instructor_imported: "Eğitmen Excel İle Yüklendi",
  instructor_activated: "Eğitmen Aktif Edildi",
  instructor_deactivated: "Eğitmen Pasif Edildi",
  vehicle_created: "Araç Oluşturuldu",
  vehicle_updated: "Araç Güncellendi",
  vehicle_imported: "Araç Excel İle Yüklendi",
  vehicle_activated: "Araç Aktif Edildi",
  vehicle_deactivated: "Araç Pasif Edildi",
  vehicle_km_updated: "Araç KM Güncellendi",
  vehicle_km_updated_via_lesson_report: "Araç KM Ders Raporundan Güncellendi",
  appointment_created: "Randevu Oluşturuldu",
  appointment_updated: "Randevu Güncellendi",
  appointment_cancelled: "Randevu İptal Edildi",
  appointment_reactivated: "Randevu Yeniden Aktifleştirildi",
  appointment_moved: "Randevu Taşındı",
  appointment_override_accepted: "Çakışma İstisnası Onaylandı",
  appointment_created_via_auto_plan: "Randevu Otomatik Planla Oluşturuldu",
  appointment_cancelled_via_auto_plan_revert: "Otomatik Plan Geri Alındı",
  auto_plan_committed: "Otomatik Plan Onaylandı",
  auto_plan_reverted: "Otomatik Plan Geri Alındı",
  lesson_report_submitted: "Ders Raporu Girildi",
  lesson_report_updated: "Ders Raporu Güncellendi",
  report_exported: "Rapor Dışa Aktarıldı",
  notification_created_from_scan: "Bildirim Taramadan Oluşturuldu",
  user_created: "Kullanıcı Oluşturuldu",
  user_updated: "Kullanıcı Güncellendi",
  user_role_changed: "Kullanıcı Rolü Değişti",
  user_active_changed: "Kullanıcı Durumu Değişti",
  user_password_reset: "Kullanıcı Parolası Sıfırlandı",
  user_deleted: "Kullanıcı Silindi",
};

export function labelEntityType(value: string): string {
  return ENTITY_TYPE_LABELS[value] || value;
}

export function labelActionType(value: string): string {
  return ACTION_TYPE_LABELS[value] || value;
}

export function actionGroup(action: string): "create" | "update" | "delete" | "system" | "neutral" {
  if (action.endsWith("_created") || action.endsWith("_submitted") || action.endsWith("_imported")) {
    return "create";
  }
  if (
    action.endsWith("_cancelled") ||
    action.endsWith("_deactivated") ||
    action.endsWith("_reverted") ||
    action.endsWith("_deleted")
  ) {
    return "delete";
  }
  if (
    action.endsWith("_updated") ||
    action.endsWith("_moved") ||
    action.endsWith("_changed") ||
    action.endsWith("_accepted") ||
    action.endsWith("_committed") ||
    action.endsWith("_km_updated") ||
    action.endsWith("_activated")
  ) {
    return "update";
  }
  if (action.startsWith("notification_") || action.startsWith("report_")) {
    return "system";
  }
  return "neutral";
}
